module.exports = __webpack_public_path__ + "static/img/AcWing.cc2b2190.png";